import React from 'react';
import { TextLarge, TextRegular, TextSmall } from '@hz-design-system/web-ui';

import Classes from './ListingTitle.module.scss';

interface ListingTitleProps {
  title: string;
  strong?: boolean;
}

interface ListingTitleComponent {
  Large: React.FC<ListingTitleProps>;
  Regular: React.FC<ListingTitleProps>;
  Small: React.FC<ListingTitleProps>;
}

const ListingTitleLarge: React.FC<ListingTitleProps> = ({ title, strong = false }) => (
  <TextLarge strong={strong} className={Classes['hz-Listing-title-new']}>
    {title}
  </TextLarge>
);

const ListingTitleRegular: React.FC<ListingTitleProps> = ({ title, strong = false }) => (
  <TextRegular strong={strong} className={Classes['hz-Listing-title-new']}>
    {title}
  </TextRegular>
);

const ListingTitleSmall: React.FC<ListingTitleProps> = ({ title, strong = false }) => (
  <TextSmall strong={strong} className={Classes['hz-Listing-title-new']}>
    {title}
  </TextSmall>
);

const ListingTitle: ListingTitleComponent = {
  Large: ListingTitleLarge,
  Regular: ListingTitleRegular,
  Small: ListingTitleSmall,
};

export default ListingTitle;
